import Http from './base-http'

class Company extends Http {
  createOnboardingThirdStepData(data) {
    return this.client.post(`registration/thirdstep`, data)
  }
  updateCompany(id,data) {
    return this.client.put(`${id}`, data)
  }
  deleteCompany(id) {
    return this.destroy(id, { timeout : 600000 });
  }
}

const company = new Company({
  modelUrlPrefix : 'company'
})

export default company
